import React from "react";
import styles from "./styles.m.css";
import { VikatanResponsiveHeader, VikatanStoryHeader } from "../../rows/ad-free";
import { PAGE_TYPE } from "../../../constants";
import PropTypes from "prop-types";
const HeaderAdUnit = props => {
  return (
    <div>
      {PAGE_TYPE.STORY_FEED ? (
        <VikatanStoryHeader />
      ) : (
        <div className={styles["header-ad-unit"]}>
          <VikatanResponsiveHeader />
        </div>
      )}
    </div>
  );
};

export default HeaderAdUnit;

HeaderAdUnit.propTypes = {
  pageType: PropTypes.string
};
